var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"subheading page-flow"},[_c('v-container',{attrs:{"fluid":""}},[(_vm.ready)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }